// extracted by mini-css-extract-plugin
export default {"Placeholder":"Style_Placeholder__6JtL5","icon":"Style_icon__I0nhZ","content":"Style_content__PAlx4"};